import { connect } from 'react-redux';

import Redaction from './Redaction';
import {
  getRedaction,
  clearRedaction,
} from '../../../store/admin/redaction/actions';

const mapStateToProps = (state) => ({
  loading: state?.admin?.redaction?.loading,
  data: state?.admin?.redaction?.data,
});

const mapDispatchToProps = (dispatch) => ({
  getRedaction: (period) => dispatch(getRedaction(period)),
  clearRedaction: () => dispatch(clearRedaction()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Redaction);
